import errorDataReducer from "./reducer";

export default function errorDataModule() {
  return {
    id: "errorDataReducer",
    reducerMap: {
      errorDataReducer
    },
    sagas: [],
    retained: true
  };
}
